import i18n from '@/locales/i18n'
import { MyAccountView } from '@rfc/rfc-components-library'
import { MY_ACCOUNT_ROUTE } from '@rfc/rfc-components-library/router'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const MY_ACCOUNT_ROUTE_NAME = 'myAccount'

const routes: RouteType[] = [
    {
        path: MY_ACCOUNT_ROUTE,
        name: MY_ACCOUNT_ROUTE_NAME,
        component: MyAccountView,
        meta: {
            title: i18n.global.t('menu.myAccount')
        }
    }
]

export default routes
